const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/aboutus"],
    exact: true,
    component: "AboutUs",
  },
  {
    path: ["/partners"],
    exact: true,
    component: "Partners",
  },
  {
    path: ["/networks"],
    exact: true,
    component: "Networks",
  },
  {
    path: ["/session-border-controler"],
    exact: true,
    component: "Sbcs",
  },
  {
    path: ["/business-process-ticketing"],
    exact: true,
    component: "Businesss",
  },
  {
    path: ["/customer-relationship-management"],
    exact: true,
    component: "Crms",
  },
  {
    path: ["/unified-communication-contact-center"],
    exact: true,
    component: "Ucncc",
  },
  {
    path: ["/ourcustomer"],
    exact: true,
    component: "OurCustomer",
  },
  {
    path: ["/visionmission"],
    exact: true,
    component: "VisionMission",
  },
  {
    path: ["/contact"],
    exact: true,
    component: "Contact",
  },
  {
    path: ["/dashboard"],
    exact: true,
    component: "Dashboard",
  },
  {
    path: ["/login"],
    exact: true,
    component: "Login",
  },
  {
    path: ["/dashboard/articles"],
    exact: true,
    component: "Articles",
  },
  {
    path: ["/dashboard/products"],
    exact: true,
    component: "Products",
  },
  {
    path: ["/dashboard/users"],
    exact: true,
    component: "Users",
  },
  {
    path: ["/productlist"],
    exact: true,
    component: "ProductList",
  },
  {
    path: ["/productdetail/:id"],
    exact: true,
    component: "ProductDetail",
  },
  {
    path: ["/articlelist"],
    exact: true,
    component: "ArticleList",
  },
  {
    path: ["/articledetail/:id"],
    exact: true,
    component: "ArticleDetail",
  },
  {
    path: ["/services"],
    exact: true,
    component: "Service",
  },
  {
    path: ["/profesionalservices"],
    exact: true,
    component: "ProfesionalServices",
  },
  {
    path: ["/maintenanceservices"],
    exact: true,
    component: "ProfesionalServices",
  },
  {
    path: ["/applicationdevelopment"],
    exact: true,
    component: "ProfesionalServices",
  },
];

export default routes;
